var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "add-role" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "option-dialog",
          staticStyle: { "margin-top": "12vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "589px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.type == 1 ? "新增角色" : "编辑角色"))
          ]),
          _c(
            "el-form",
            {
              ref: "myForm",
              staticClass: "xForm",
              attrs: {
                model: _vm.showParams,
                "label-width": "110px",
                center: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "角色名", prop: "roleName" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      size: "medium",
                      autocomplete: "off",
                      maxlength: "8",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.showParams.roleName,
                      callback: function($$v) {
                        _vm.$set(_vm.showParams, "roleName", $$v)
                      },
                      expression: "showParams.roleName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述", prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入内容",
                      maxlength: "30",
                      "show-word-limit": "",
                      resize: "none"
                    },
                    model: {
                      value: _vm.showParams.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.showParams, "remark", $$v)
                      },
                      expression: "showParams.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { size: "small" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "confirm-btn",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }